import React, { useRef } from 'react';

import formatShopLink from 'utils/format-shop-link';
import { useNavigation } from 'components/MegaMenu/NavigationProvider';

import styles from '../SpecialistShopsLinks.scss';

type Props = {
  link: {
    name: string;
    tracking: string;
    url: string;
  };
  target?: string;
};

const SpecialistShopLink = ({ link, target }: Props) => {
  const ref = useRef(null);
  const { handleClick, handleKeyDown, tabIndex } = useNavigation(ref);

  return (
    <a
      className={styles.link}
      href={formatShopLink(link)}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      ref={ref}
      rel="noopener noreferrer"
      tabIndex={Number(tabIndex)}
      target={target || '_blank'}
    >
      {link.name}
    </a>
  );
};

SpecialistShopLink.displayName = 'SpecialistShopLink';

export default SpecialistShopLink;
